import { render, staticRenderFns } from "./PaymentBankChannelsTable.vue?vue&type=template&id=640efe62&scoped=true&"
import script from "./PaymentBankChannelsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentBankChannelsTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBankChannelsTable.vue?vue&type=style&index=0&id=640efe62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640efe62",
  null
  
)

export default component.exports